import { useState } from "react";

import DestinatariosCard from "./components/DestinatariosCard";
import MensajeCard from "./components/MensajeCard";
import AdjuntosCard from "./components/AdjuntosCard";
import PreviewCard from "./components/PreviewCard";
import HistorialTab from "./components/HistorialTab";

import {
  sendCampaign,
  sendCampaignWithAttachments,
} from "./services/campaignApi";

import "./CampanasMail.css";

const RECIPIENT_MODE_LABELS = {
  all: "todos los destinatarios",
  psychology: "los pacientes de Psicología",
  logopedia: "los pacientes de Logopedia",
  nutrition: "los pacientes de Nutrición",
  manual: "los destinatarios seleccionados",
};

const INITIAL_CAMPAIGN = {
  subject: "",
  body: "",

  // all | psychology | logopedia | nutrition | manual
  recipientMode: "all",

  recipients: [],
  attachments: [],
  sendCopy: true,
};

export default function CampanasMail() {
  const [activeTab, setActiveTab] = useState("campaign");

  const [campaign, setCampaign] = useState(INITIAL_CAMPAIGN);

  const [sending, setSending] = useState(false);
  const [sendResult, setSendResult] = useState(null);
  const [sendError, setSendError] = useState("");

  function validateCampaign() {
    if (!campaign.subject.trim()) {
      return "Escribe un asunto.";
    }

    if (!campaign.body.trim()) {
      return "Escribe un mensaje.";
    }

    if (
      campaign.recipientMode === "manual" &&
      campaign.recipients.length === 0
    ) {
      return "Selecciona al menos un destinatario.";
    }

    return null;
  }

  function getConfirmationMessage() {
    if (campaign.recipientMode === "manual") {
      const total = campaign.recipients.length;

      return `¿Enviar la campaña a ${total} ${
        total === 1 ? "destinatario" : "destinatarios"
      }?`;
    }

    const recipientLabel =
      RECIPIENT_MODE_LABELS[campaign.recipientMode] ||
      "los destinatarios indicados";

    return `¿Enviar la campaña a ${recipientLabel}?`;
  }

  async function handleSendCampaign() {
    const validationError = validateCampaign();

    if (validationError) {
      window.alert(validationError);
      return;
    }

    if (!window.confirm(getConfirmationMessage())) {
      return;
    }

    try {
      setSending(true);
      setSendError("");
      setSendResult(null);

      const hasAttachments =
        Array.isArray(campaign.attachments) && campaign.attachments.length > 0;

      const response = hasAttachments
        ? await sendCampaignWithAttachments(campaign)
        : await sendCampaign(campaign);

      setSendResult(response);

      const sent = Number(response?.sent || 0);
      const failed = Number(response?.failed || 0);

      window.alert(
        [
          "Campaña enviada correctamente.",
          "",
          `Enviados: ${sent}`,
          `Fallidos: ${failed}`,
        ].join("\n"),
      );

      setCampaign({
        ...INITIAL_CAMPAIGN,
        recipients: [],
        attachments: [],
      });

      setActiveTab("history");
    } catch (error) {
      console.error("Error enviando la campaña:", error);

      setSendError(error?.message || "No se pudo enviar la campaña.");
    } finally {
      setSending(false);
    }
  }

  return (
    <div className="campaign-page">
      <header className="campaign-header">
        <div>
          <h1>
            <i className="fa-solid fa-paper-plane" aria-hidden="true" />
            <span>Comunicaciones</span>
          </h1>

          <p>Envía campañas de correo a pacientes y familias del centro.</p>
        </div>
      </header>

      <nav className="campaign-tabs" aria-label="Secciones de comunicaciones">
        <button
          type="button"
          className={activeTab === "campaign" ? "active" : ""}
          aria-pressed={activeTab === "campaign"}
          onClick={() => setActiveTab("campaign")}
        >
          <i className="fa-solid fa-paper-plane" aria-hidden="true" />
          <span>Nueva campaña</span>
        </button>

        <button
          type="button"
          className={activeTab === "history" ? "active" : ""}
          aria-pressed={activeTab === "history"}
          onClick={() => setActiveTab("history")}
        >
          <i className="fa-solid fa-clock-rotate-left" aria-hidden="true" />
          <span>Historial</span>
        </button>

      </nav>

      {activeTab === "campaign" && (
        <div className="campaign-grid">
          <DestinatariosCard campaign={campaign} setCampaign={setCampaign} />

          <MensajeCard campaign={campaign} setCampaign={setCampaign} />

          <AdjuntosCard campaign={campaign} setCampaign={setCampaign} />

          <PreviewCard campaign={campaign} />

          <div className="campaign-actions">
            <div className="campaign-status" aria-live="polite">
              {sendError && (
                <div className="campaign-error">
                  <i
                    className="fa-solid fa-circle-exclamation"
                    aria-hidden="true"
                  />
                  <span>{sendError}</span>
                </div>
              )}

              {sendResult && (
                <div className="campaign-success">
                  <i className="fa-solid fa-circle-check" aria-hidden="true" />

                  <span>
                    Campaña enviada correctamente.{" "}
                    <strong>{Number(sendResult.sent || 0)}</strong> enviados.
                    {Number(sendResult.failed || 0) > 0 && (
                      <>
                        {" "}
                        <strong>{Number(sendResult.failed || 0)}</strong>{" "}
                        fallidos.
                      </>
                    )}
                  </span>
                </div>
              )}
            </div>

            <button
              type="button"
              className="campaign-send-button"
              disabled={sending}
              onClick={handleSendCampaign}
            >
              {sending ? (
                <>
                  <i
                    className="fa-solid fa-spinner fa-spin"
                    aria-hidden="true"
                  />
                  <span>Enviando...</span>
                </>
              ) : (
                <>
                  <i className="fa-solid fa-paper-plane" aria-hidden="true" />
                  <span>Enviar campaña</span>
                </>
              )}
            </button>
          </div>
        </div>
      )}

      {activeTab === "history" && <HistorialTab />}

    </div>
  );
}
